import * as sdk from "matrix-js-sdk";
import PmsUrlConfig from "../../urlConfig";
import {submitAppointmentAudit} from "../appointment/appointmentFunctions";
import store from '../../redux/store.js';

// Wrap fetch to inject custom headers for all Matrix requests
const withHeadersFetch = ((origFetch) => (input, init = {}) => {
  const headers = new Headers((init && init.headers) ? init.headers : {});
  // Add your custom headers here
  headers.set("X-Custom-Header", "my-value");
  // Example: propagate app/version/tenant if needed
  // headers.set("X-App-Version", (process && process.env && process.env.REACT_APP_VERSION) || "unknown");
  return origFetch(input, { ...init, headers });
})(window.fetch);


const getMatrixClient = (myAccessToken, myUserId) => {
    console.log(`TODO:Remove. Matrix Client access_token: ${myAccessToken} for user: ${myUserId}`)
    console.log(`TODO:Remove. Matrix Client baseUrl from config: ${PmsUrlConfig.MATRIX_HOME_SERVER_URL}`)
    // console.log(`Token type check: Matrix token starts with 'syt_'? ${myAccessToken.startsWith('syt_')}`)
    const matrixClient = sdk.createClient({
            baseUrl: PmsUrlConfig.MATRIX_HOME_SERVER_URL,
            accessToken: myAccessToken,
        userId: myUserId});
        // fetchFn: withHeadersFetch,
    // });
    console.log(`Matrix client created with baseUrl: ${matrixClient.getHomeserverUrl()}`)
    matrixClient.setAccessToken(myAccessToken)
    return matrixClient;
}
const getMatrixServer = (myAccessToken, myUserId) => {
    console.log(`TODO:Remove. Matrix Server access_token: ${myAccessToken} for user: ${myUserId}`)
    const matrixServer = sdk.createClient({
            baseUrl: PmsUrlConfig.MATRIX_SYNAPSE_SERVER_URL,
            accessToken: myAccessToken,
            userId: myUserId,
            fetchFn: withHeadersFetch,
        });
    matrixServer.setAccessToken(myAccessToken)
    return matrixServer;
}

const getUserGroups = async (client, userSynapseId) => {
    try {
        console.log(`Getting groups and rooms for user: ${userSynapseId}`);
        
        // Get all joined rooms
        const joinedRooms = await client.getJoinedRooms();
        console.log("User joined rooms:", joinedRooms);
        
        const userGroups = [];
        const userRooms = [];
        
        // Check each joined room to see if it's a space (group) or regular room
        for (const roomId of joinedRooms.joined_rooms || []) {
            try {
                // Use correct Matrix client API method
                const roomState = await client.roomState(roomId);
                
                // Check if this room is a space (Matrix groups are implemented as spaces)
                const creationEvent = roomState.find(event => event.type === 'm.room.create');
                
                if (creationEvent && creationEvent.content?.type === 'm.space') {
                    // This is a space (group)
                    const nameEvent = roomState.find(event => event.type === 'm.room.name');
                    const groupName = nameEvent?.content?.name || roomId;
                    
                    userGroups.push({
                        roomId: roomId,
                        name: groupName,
                        type: 'space'
                    });
                    
                    console.log(`Found group: ${groupName} (${roomId})`);
                } else {
                    // This is a regular room
                    const nameEvent = roomState.find(event => event.type === 'm.room.name');
                    const roomName = nameEvent?.content?.name || roomId;
                    
                    userRooms.push({
                        roomId: roomId,
                        name: roomName,
                        type: 'room'
                    });
                    
                    console.log(`Found room: ${roomName} (${roomId})`);
                }
            } catch (error) {
                console.log(`Could not check room ${roomId} for state:`, error.message);
                // Add as room anyway if we can't get state
                userRooms.push({
                    roomId: roomId,
                    name: roomId,
                    type: 'room',
                    error: error.message
                });
            }
        }
        
        console.log(`User ${userSynapseId} belongs to ${userGroups.length} groups and ${userRooms.length} rooms:`);
        console.log(`Groups:`, userGroups);
        console.log(`Rooms:`, userRooms);
        
        return {
            groups: userGroups,
            rooms: userRooms,
            totalJoined: joinedRooms.joined_rooms?.length || 0
        };
        
    } catch (error) {
        console.error("Error getting user groups and rooms:", error);
        return {
            groups: [],
            rooms: [],
            totalJoined: 0,
            error: error.message
        };
    }
}


const joinUserRoom = async (client, roomId, userSynapseId, dispatch) => {
    try {
        console.log(`Attempting to join user ${userSynapseId} to room ${roomId}`);
        
        if (!client) {
            console.error("Matrix client not available");
            return false;
        }

        // First, get current room members to check if user is already a member
        let roomMembersResponse;
        try {
            roomMembersResponse = await client.getJoinedRoomMembers(roomId);
        } catch (error) {
            console.log("Could not get room members, assuming user is not a member:", error.message);
            roomMembersResponse = { joined: [] };
        }

        const joinedMembers = roomMembersResponse.joined || [];
        const isUserAlreadyInRoom = joinedMembers.includes(userSynapseId);
        
        console.log("Current room members:", joinedMembers);
        console.log("User is already in room:", isUserAlreadyInRoom);

        if (isUserAlreadyInRoom) {
            console.log(`✅ User ${userSynapseId} is already a member of room ${roomId}, proceeding with chat...`);
            // User is already in room, just update the UI and sync
            getJoinedRoomsForUser(client, dispatch);
            await getRoomInitialSync(roomId, client, dispatch);
            return true;
        }

        // User is not in room, try to join
        console.log(`User ${userSynapseId} is not in room, attempting to join...`);
        try {
            const joinResponse = await client.joinRoom(roomId);
            console.log("Successfully joined room:", joinResponse);
            
            // Update room list and sync messages
            getJoinedRoomsForUser(client, dispatch);
            await getRoomInitialSync(roomId, client, dispatch);
            return true;
            
        } catch (joinError) {
            console.error("Failed to join room:", joinError);
            
            // Check if error is because user is already in room (some Matrix servers return this error)
            if (joinError.errcode === 'M_FORBIDDEN' && 
                joinError.message && 
                joinError.message.includes('already in the room')) {
                console.log(`User ${userSynapseId} is already in room (detected via error), proceeding with chat...`);
                
                // Even though we got an error, the user can still chat
                getJoinedRoomsForUser(client, dispatch);
                await getRoomInitialSync(roomId, client, dispatch);
                return true;
            }
            
            // Check if error is because room is restricted and user needs to be invited
            if (joinError.errcode === 'M_FORBIDDEN' && 
                (joinError.message?.includes('required rooms/spaces') || 
                 joinError.message?.includes('not in room'))) {
                console.log(`Room ${roomId} is restricted, checking user group membership...`);
                
                try {
                    // Get user's group memberships
                    const userGroups = await getUserGroups(client, userSynapseId);
                    console.log(`User belongs to ${userGroups.length} groups:`, userGroups);
                    
                    // Get room information to check required groups/spaces
                    const roomInfo = await client.roomState(roomId);
                    console.log("Room state info:", roomInfo);
                    
                    // Check for space/room membership rules
                    const joinRules = roomInfo.find(event => event.type === 'm.room.join_rules');
                    if (joinRules) {
                        console.log("Room join rules:", joinRules);
                    }
                    
                    // Check for space parent (which indicates required group membership)
                    const spaceParent = roomInfo.find(event => event.type === 'm.space.parent');
                    if (spaceParent) {
                        console.log("Room space parent:", spaceParent);
                        console.log("Required space:", spaceParent.content?.space_id);
                        
                        // Check if user belongs to the required space
                        const requiredSpaceId = spaceParent.content?.space_id;
                        const userBelongsToRequiredSpace = userGroups.some(group => 
                            group.roomId === requiredSpaceId
                        );
                        
                        if (userBelongsToRequiredSpace) {
                            console.log(`User has required group membership for space ${requiredSpaceId}`);
                            
                            // Try to join again - should work now that we confirmed group membership
                            console.log("Attempting to join via confirmed group membership access...");
                            const groupJoinResponse = await client.joinRoom(roomId);
                            console.log("Successfully joined room via group access:", groupJoinResponse);
                            
                            // Update room list and sync messages
                            getJoinedRoomsForUser(client, dispatch);
                            await getRoomInitialSync(roomId, client, dispatch);
                            return true;
                        } else {
                            console.log(`User does NOT belong to required space ${requiredSpaceId}`);
                            console.log("User groups:", userGroups.map(g => `${g.name} (${g.roomId})`));
                        }
                    }
                    
                    // If group membership check didn't work, try direct invite as fallback
                    console.log("Group access verification failed, attempting direct invite...");
                    try {
                        const inviteResponse = await client.invite(roomId, userSynapseId);
                        console.log("Successfully invited user to room:", inviteResponse);
                        
                        // Now try to join again
                        const secondJoinResponse = await client.joinRoom(roomId);
                        console.log("Successfully joined room after invite:", secondJoinResponse);
                        
                        // Update room list and sync messages
                        getJoinedRoomsForUser(client, dispatch);
                        await getRoomInitialSync(roomId, client, dispatch);
                        return true;
                        
                    } catch (inviteError) {
                        console.error("Direct invite also failed:", inviteError);
                        
                        if (inviteError.errcode === 'M_FORBIDDEN') {
                            console.log(`User ${userSynapseId} lacks group membership and cannot self-invite to restricted room ${roomId}`);
                            console.log("User needs to be added to the appropriate group or invited by a room administrator");
                            
                            // Still try to show chat interface in case they have some access
                            getJoinedRoomsForUser(client, dispatch);
                            await getRoomInitialSync(roomId, client, dispatch);
                            return false;
                        }
                    }
                    
                } catch (groupCheckError) {
                    console.error("Error checking group membership:", groupCheckError);
                    
                    // Fallback: try direct invite
                    try {
                        const inviteResponse = await client.invite(roomId, userSynapseId);
                        console.log("Successfully invited user to room (fallback):", inviteResponse);
                        
                        const secondJoinResponse = await client.joinRoom(roomId);
                        console.log("Successfully joined room after invite (fallback):", secondJoinResponse);
                        
                        getJoinedRoomsForUser(client, dispatch);
                        await getRoomInitialSync(roomId, client, dispatch);
                        return true;
                        
                    } catch (fallbackError) {
                        console.error("All access methods failed:", fallbackError);
                        
                        getJoinedRoomsForUser(client, dispatch);
                        await getRoomInitialSync(roomId, client, dispatch);
                        return false;
                    }
                }
            }
            
            // For other errors, still try to sync what we can
            getJoinedRoomsForUser(client, dispatch);
            await getRoomInitialSync(roomId, client, dispatch);
            return false;
        }

    } catch (error) {
        console.error("❌ Unexpected error in joinUserRoom:", error);
        return false;
    }
}

const getJoinedRoomsForUser = (client, dispatch) => {
    console.log("GETTING ROOMS");
    if (client && client.store) {
        console.log("Got ROOMS: ", client.store.rooms);
        dispatch({
            type: 'setJoinedRooms',
            payload: client.store.rooms
        })
    }
}
const matrixInitialSync = (roomIdArray, client, dispatch) => {
    console.log("INITIAL SYNC");

    for (let i = 0; i < roomIdArray.length; i++) {

        getJoinedMembers(roomIdArray[i], client, dispatch);

    }
}

const getRoomInitialSync = async (roomId, client, dispatch) => {
    try {
        if (!client || typeof client.getRoom !== 'function' || typeof client.paginateEventTimeline !== 'function') {
            throw new Error('Invalid Matrix client passed to getRoomInitialSync');
        }

        // First, try to load cached messages from localStorage for immediate display
        try {
            const allChatMessages = JSON.parse(localStorage.getItem('chatMessages') || '{}');
            const roomData = allChatMessages[roomId];
            if (roomData && roomData.messages) {
                // Check if messages are not too old (24 hours)
                const currentTime = Date.now();
                const twentyFourHours = 24 * 60 * 60 * 1000;
                if (currentTime - roomData.timestamp < twentyFourHours) {
                    console.log(`Loaded ${roomData.messages.length} cached messages for room ${roomId}`);
                    if (typeof dispatch === 'function') {
                        dispatch({ type: 'setSynapseEvents', payload: roomData.messages });
                    }
                }
            }
        } catch (error) {
            console.error('Error loading cached messages:', error);
        }

        // Ensure membership and room presence in store
        let room = client.getRoom(roomId);
        if (!room) {
            try { await client.joinRoom(roomId); } catch (e) { /* ignore join errors */ }
            room = client.getRoom(roomId);
        }
        if (!room) {
            console.warn('Room not found in client store', roomId);
            if (typeof dispatch === 'function') {
                dispatch({ type: 'setSynapseEvents', payload: [] });
            }
            return;
        }

        // Use supported timeline pagination
        const liveTimeline = room.getLiveTimeline();
        await client.paginateEventTimeline(liveTimeline, { backwards: true }, 50);

        // Collect events (live + prev chunks known to the room)
        const events = liveTimeline.getEvents ? liveTimeline.getEvents() : (room.timeline || []);
        const msgChunks = events
            .filter((evt) => evt && typeof evt.getType === 'function' && evt.getType() === 'm.room.message')
            .map((evt) => evt.event);

        if (msgChunks.length > 0) {
            console.log(`Loaded ${msgChunks.length} fresh messages for room ${roomId}`);
        }
        
        // Save room members to localStorage for persistence
        try {
            if (room.currentState && room.currentState.members) {
                const allRoomMembers = JSON.parse(localStorage.getItem('roomMembers') || '{}');
                allRoomMembers[roomId] = {
                    members: room.currentState.members,
                    timestamp: Date.now()
                };
                localStorage.setItem('roomMembers', JSON.stringify(allRoomMembers));
            }
        } catch (error) {
            console.error('Error saving room members to storage:', error);
        }
        
        // Save to localStorage for persistence
        try {
            const allChatMessages = JSON.parse(localStorage.getItem('chatMessages') || '{}');
            allChatMessages[roomId] = {
                messages: msgChunks,
                timestamp: Date.now()
            };
            localStorage.setItem('chatMessages', JSON.stringify(allChatMessages));
            localStorage.setItem('chatMessagesTimestamp', Date.now().toString());
        } catch (error) {
            console.error('Error saving chat messages to storage:', error);
        }
        
        if (typeof dispatch === 'function') {
            dispatch({ type: 'setSynapseEvents', payload: msgChunks });
        }
    } catch (error) {
        console.error('getRoomInitialSync error:', error.message);
        console.error('Error details:', {
            httpStatus: error.httpStatus,
            errcode: error.errcode,
            message: error.message
        });
        
        // Check if it's an access/permission error and re-throw it
        if (error.httpStatus === 403 || error.errcode === 'M_FORBIDDEN' || error.message?.includes('Forbidden')) {
            console.error('Access denied error detected, re-throwing...');
            throw error;
        }
        
        // For other errors, handle gracefully
        if (typeof dispatch === 'function') {
            dispatch({ type: 'setSynapseEvents', payload: null });
        }
    }
}

const getJoinedMembers = async (roomId, client, dispatch) => {
    var roomMembersResp = client.getJoinedRoomMembers(roomId);
    var joinedMembers = null
    roomMembersResp.then(function (response) {
        joinedMembers = response.joined;
        return joinedMembers;
    },
        function (error) {
            console.error('getJoinedMembers error:', error);
            // return {roomId, joinedMembers};
        }).then(joinedMembers => {
            if (joinedMembers && joinedMembers.length > 0) {
                console.log(`Found ${joinedMembers.length} members in room ${roomId}`);
            }
            return joinedMembers;
        })

}

const getRoomNotificationCounts = (client, dispatch) => {
    console.log('=== GET ROOM NOTIFICATION COUNTS CALLED ===');
    console.log('Timestamp:', new Date().toISOString());
    console.log('Matrix client available:', !!client);
    console.log('Client store available:', !!(client && client.store));
    
    var roomsNotificationCount = [];
    var roomNotificationCount = {};
    if (client && client.store) {
        var rooms = client.store.rooms;
        console.log('Total rooms in store:', Object.keys(rooms).length);
        console.log('Room keys:', Object.keys(rooms));

        var nCount = 0;
        for (const roomKey in rooms) {
            roomNotificationCount = {};
            nCount = 0;
            if (rooms[roomKey] !== null && rooms[roomKey].notificationCounts !== null) {
                nCount = rooms[roomKey].notificationCounts.total;
            }
            roomNotificationCount.roomKey = roomKey;
            roomNotificationCount.notificationCount = nCount;
            roomsNotificationCount.push(roomNotificationCount);
            console.log(`Room ${roomKey}: ${nCount} unread messages`);

        }
        console.log("NCOUNTS:", roomsNotificationCount);
        console.log('=== MATRIX NOTIFICATION UPDATE ===');
        console.log('Total rooms with notifications:', roomsNotificationCount.length);
        roomsNotificationCount.forEach(room => {
            console.log(`Room: ${room.roomKey} -> Unread: ${room.notificationCount}`);
        });
        console.log('=== END MATRIX NOTIFICATION UPDATE ===');
    } else {
        console.log('No client or store available - cannot get notification counts');
    }
    dispatch({
        type: 'setRoomsNotifications',
        payload: roomsNotificationCount
    });
    
    console.log('=== END GET ROOM NOTIFICATION COUNTS ===');
}

const getRoomUnreadMsgCount = (roomId, roomsNotifications = []) => {
    // Early return if no room ID or notifications
    if (!roomId || !roomsNotifications || roomsNotifications.length === 0) {
        return 0;
    }
    
    const room = roomsNotifications.find(r => r.roomKey === roomId);
    return room?.notificationCount ?? 0;
};

const updateRoomNotificationCount = (roomId, newCount, dispatch) => {
    console.log('=== UPDATE ROOM NOTIFICATION COUNT ===');
    console.log('Room ID:', roomId);
    console.log('New count:', newCount);
    
    // Get current state
    const state = store.getState();
    const currentNotifications = state.appointmentDetails?.roomsNotificationCount || [];
    
    // Update the specific room's count
    const updatedNotifications = currentNotifications.map(room => {
        if (room.roomKey === roomId) {
            return {
                ...room,
                notificationCount: newCount
            };
        }
        return room;
    });
    
    console.log('Updated notifications:', updatedNotifications);
    
    // Dispatch the update
    dispatch({
        type: 'setRoomsNotifications',
        payload: updatedNotifications
    });
    
    console.log('=== END UPDATE ROOM NOTIFICATION COUNT ===');
};

const getTotalUnreadMsgCountForAppointment = (roomIds, roomsNotifications) => {
    var nCount = 0;
    for (let i = 0; i < roomsNotifications.length; i++) {
        for (let j = 0; j < roomIds.length; j++) {
            if (roomsNotifications[i].roomKey === roomIds[j]) {
                nCount = nCount + roomsNotifications[i].notificationCount;
            }
        }
    }
    return nCount;
}

const markRead = (user, matrixClient, selectedRoom) => {
    var eventsCount = 0;
    var lastEvent = "";
    if (selectedRoom && selectedRoom.timeline && selectedRoom.timeline.length > 0) {
        eventsCount = selectedRoom.timeline.length;
        for (let c = eventsCount; c > 0; c--) {
            lastEvent = selectedRoom.timeline[c - 1];
            if (lastEvent.sender !== user.synapse_user_id) {
                break;
            }
        }
    }

    if (!matrixClient) {
        console.log('=== MARK READ DEBUG ===');
        console.log('User access_token:', user.access_token);
        console.log('User synapse_token:', user.synapse_token);
        console.log('User synapse_user_id:', user.synapse_user_id);
        console.log('=== END MARK READ DEBUG ===');
        
        matrixClient = getMatrixClient(user.synapse_token, user.synapse_user_id);
    }
    // var markReadResp = matrixClient.setRoomReadMarkers(roomId, eventID);
    console.log("LastEvent:", lastEvent)
    var markReadResp = matrixClient.sendReadReceipt(lastEvent, "m.read", false);
    markReadResp.then((response) => {
        console.log("MARK READ: ", response);
    }).catch((error) => {
        console.log("MARK READ-->ERROR:", error);
    });
}

const verifyAndJoinStaffUser = async (loggedInUser, matrixClient, roomId, appt_id, dispatch) => {
    console.log("🔍 === verifyAndJoinStaffUser START ===");
    console.log("🔍 loggedInUser:", loggedInUser);
    console.log("🔍 matrixClient:", matrixClient ? "exists" : "null");
    console.log("🔍 roomId:", roomId);
    console.log("🔍 appt_id:", appt_id);
    console.log("🔍 appt_id type:", typeof appt_id);
    console.log("🔍 appt_id length:", appt_id ? appt_id.length : "null");
    console.log("🔍 dispatch:", dispatch ? "exists" : "null");
    
    try {
        if (!matrixClient) {
            console.error("❌ Matrix client not available");
            return false;
        }

        if (!loggedInUser || !loggedInUser.synapse_user_id) {
            console.error("❌ Invalid user data for room verification");
            console.error("❌ loggedInUser:", loggedInUser);
            console.error("❌ synapse_user_id:", loggedInUser?.synapse_user_id);
            return false;
        }

        console.log(`🔍 Verifying staff user ${loggedInUser.synapse_user_id} membership in room ${roomId}`);

        // First try to get room members to check if user is already a member
        console.log("🔍 Getting room members...");
        let isUserMember = false;
        
        try {
            const roomMembersResponse = await matrixClient.getJoinedRoomMembers(roomId);
            console.log("🔍 Room members response:", roomMembersResponse);
            
            const joinedMembers = roomMembersResponse?.joined || {};
            console.log("🔍 Joined members:", joinedMembers);
            console.log("🔍 Joined members count:", Array.isArray(joinedMembers)
                ? joinedMembers.length
                : Object.keys(joinedMembers).length);

            // Synapse returns joined members keyed by user ID; also accept an array response.
            isUserMember = Array.isArray(joinedMembers)
                ? joinedMembers.includes(loggedInUser.synapse_user_id)
                : Object.prototype.hasOwnProperty.call(joinedMembers, loggedInUser.synapse_user_id);
            console.log("🔍 Is user already a member?", isUserMember);
            console.log("🔍 Looking for user ID:", loggedInUser.synapse_user_id);
            console.log("🔍 In members list:", joinedMembers);

            if (isUserMember) {
                console.log(`✅ Staff user ${loggedInUser.synapse_user_id} is already a member of room ${roomId}`);
                return true;
            }
        } catch (memberCheckError) {
            console.log("🔍 Could not check room members (likely not a member):", memberCheckError.message);
            // User is probably not a member, continue with invite/join process
        }

        // User is not a member, need to invite and join
        console.log(`🔍 Staff user ${loggedInUser.synapse_user_id} is not a member, attempting to invite and join...`);
        
        try {
            // First, try to invite the user to the room
            console.log("🔍 Attempting to invite user to room...");
            const inviteResponse = await matrixClient.invite(roomId, loggedInUser.synapse_user_id);
            console.log("🔍 Invite response:", inviteResponse);
            
            if (inviteResponse && inviteResponse.room_id) {
                console.log("✅ Successfully invited user to room");
                
                // Now try to join the room
                console.log("🔍 Attempting to join room after invitation...");
                const joinResponse = await matrixClient.joinRoom(roomId);
                console.log("🔍 Join response:", joinResponse);
                
                if (joinResponse && joinResponse.room_id) {
                    console.log(`✅ Successfully joined room ${roomId}:`, joinResponse);
                    
                    // Submit audit log for user joining room
                    console.log("🔍 === AUDIT SUBMISSION START ===");
                    console.log("🔍 Scenario: User successfully joined room after invite");
                    console.log("🔍 Room ID:", roomId);
                    console.log("🔍 User ID:", loggedInUser._id);
                    console.log("🔍 Username:", loggedInUser.username);
                    console.log("🔍 Email:", loggedInUser.email);
                    console.log("🔍 Token exists:", !!loggedInUser.token);
                    console.log("🔍 Associate (will be sent):", loggedInUser.username || loggedInUser.email);
                    console.log("🔍 Timestamp (will be sent):", new Date().toISOString());
                    
                    try {
                        const auditResult = await submitAppointmentAudit(
                            appt_id, 
                            loggedInUser,
                            loggedInUser.token
                        );
                        console.log("🔍 Audit submission result:", auditResult);
                        if (auditResult.success) {
                            console.log("✅ Audit log submitted successfully for user joining room");
                        } else {
                            console.error("❌ Failed to submit audit log:", auditResult.error);
                        }
                    } catch (auditError) {
                        console.error("❌ Error submitting audit log:", auditError);
                        console.error("❌ Audit error details:", {
                            message: auditError.message,
                            stack: auditError.stack,
                            name: auditError.name
                        });
                    }
                    console.log("🔍 === AUDIT SUBMISSION END ===");
                    
                    // Update joined rooms list
                    console.log("🔍 Updating joined rooms list...");
                    getJoinedRoomsForUser(matrixClient, dispatch);
                    
                    // Get initial sync for the room
                    console.log("🔍 Getting initial room sync...");
                    await getRoomInitialSync(roomId, matrixClient, dispatch);
                    
                    console.log("✅ Room join process completed successfully");
                    return true;
                } else {
                    console.error("❌ Failed to join room after invitation - invalid response:", joinResponse);
                    return false;
                }
            } else {
                console.error("❌ Failed to invite user - invalid response:", inviteResponse);
                return false;
            }
        } catch (inviteJoinError) {
            console.error("❌ Error during invite/join process:", inviteJoinError);
            console.error("❌ Error details:", {
                message: inviteJoinError.message,
                stack: inviteJoinError.stack,
                name: inviteJoinError.name,
                httpStatus: inviteJoinError.httpStatus,
                errcode: inviteJoinError.errcode
            });
            
            // Check if the error is because user is already in the room
            if (inviteJoinError.errcode === 'M_FORBIDDEN' && 
                inviteJoinError.message && 
                inviteJoinError.message.includes('already in the room')) {
                console.log("✅ User is already in the room, proceeding with chat...");
                
                // Submit audit log for user accessing room they're already in
                console.log("🔍 === AUDIT SUBMISSION START ===");
                
                try {
                    const auditResult = await submitAppointmentAudit(
                        appt_id, 
                        loggedInUser.username || loggedInUser.email, 
                        loggedInUser.jwt_token
                    );
                    console.log("🔍 Audit submission result:", auditResult);
                    if (auditResult.success) {
                        console.log("✅ Audit log submitted successfully for user accessing room (already member)");
                    } else {
                        console.error("❌ Failed to submit audit log:", auditResult.error);
                    }
                } catch (auditError) {
                    console.error("❌ Error submitting audit log:", auditError);
                    console.error("❌ Audit error details:", {
                        message: auditError.message,
                        stack: auditError.stack,
                        name: auditError.name
                    });
                }
                console.log("🔍 === AUDIT SUBMISSION END ===");
                
                // Update joined rooms list and sync
                getJoinedRoomsForUser(matrixClient, dispatch);
                await getRoomInitialSync(roomId, matrixClient, dispatch);
                
                return true;
            }
            
            // If invite/join fails, try direct join as fallback
            console.log("🔍 Attempting fallback direct join to room:", roomId);
            try {
                const fallbackResponse = await matrixClient.joinRoom(roomId);
                console.log("🔍 Fallback join response:", fallbackResponse);
                if (fallbackResponse && fallbackResponse.room_id) {
                    console.log("✅ Fallback join successful:", fallbackResponse);
                    
                    // Submit audit log for user joining room
                    console.log("🔍 === AUDIT SUBMISSION START ===");
                    console.log("🔍 Scenario: User successfully joined room via fallback direct join");
                    console.log("🔍 Room ID:", roomId);
                    console.log("🔍 User ID:", loggedInUser._id);
                    console.log("🔍 Username:", loggedInUser.username);
                    console.log("🔍 Email:", loggedInUser.email);
                    console.log("🔍 Token exists:", !!loggedInUser.token);
                    console.log("🔍 Associate (will be sent):", loggedInUser.username || loggedInUser.email);
                    console.log("🔍 Timestamp (will be sent):", new Date().toISOString());
                    
                    try {
                        const auditResult = await submitAppointmentAudit(
                            appt_id, 
                            loggedInUser,
                            loggedInUser.token
                        );
                        console.log("🔍 Audit submission result:", auditResult);
                        if (auditResult.success) {
                            console.log("✅ Audit log submitted successfully for user joining room (fallback)");
                        } else {
                            console.error("❌ Failed to submit audit log:", auditResult.error);
                        }
                    } catch (auditError) {
                        console.error("❌ Error submitting audit log:", auditError);
                        console.error("❌ Audit error details:", {
                            message: auditError.message,
                            stack: auditError.stack,
                            name: auditError.name
                        });
                    }
                    console.log("🔍 === AUDIT SUBMISSION END ===");
                    
                    getJoinedRoomsForUser(matrixClient, dispatch);
                    await getRoomInitialSync(roomId, matrixClient, dispatch);
                    return true;
                }
            } catch (fallbackError) {
                console.error("❌ Fallback join also failed:", fallbackError);
                console.error("❌ Fallback error details:", {
                    message: fallbackError.message,
                    stack: fallbackError.stack,
                    name: fallbackError.name,
                    httpStatus: fallbackError.httpStatus,
                    errcode: fallbackError.errcode
                });
                
                // Check if fallback error is also because user is already in the room
                if (fallbackError.errcode === 'M_FORBIDDEN' && 
                    fallbackError.message && 
                    fallbackError.message.includes('already in the room')) {
                    console.log("✅ User is already in the room (fallback check), proceeding with chat...");
                    
                    // Submit audit log for user accessing room they're already in
                    console.log("🔍 === AUDIT SUBMISSION START ===");
                    console.log("🔍 Scenario: User attempted fallback join but was already in room");
                    console.log("🔍 Room ID:", roomId);
                    console.log("🔍 User ID:", loggedInUser._id);
                    console.log("🔍 Username:", loggedInUser.username);
                    console.log("🔍 Email:", loggedInUser.email);
                    console.log("🔍 Token exists:", !!loggedInUser.jwt_token);
                    console.log("🔍 Associate (will be sent):", loggedInUser.username || loggedInUser.email);
                    console.log("🔍 Timestamp (will be sent):", new Date().toISOString());
                    console.log("🔍 Appointment ID:", appt_id);
                    
                    try {
                        const auditResult = await submitAppointmentAudit(
                            appt_id, 
                            loggedInUser,
                            loggedInUser.jwt_token
                        );
                        console.log("🔍 Audit submission result:", auditResult);
                        if (auditResult.success) {
                            console.log("✅ Audit log submitted successfully for user accessing room (already member - fallback)");
                        } else {
                            console.error("❌ Failed to submit audit log:", auditResult.error);
                        }
                    } catch (auditError) {
                        console.error("❌ Error submitting audit log:", auditError);
                        console.error("❌ Audit error details:", {
                            message: auditError.message,
                            stack: auditError.stack,
                            name: auditError.name
                        });
                    }
                    console.log("🔍 === AUDIT SUBMISSION END ===");
                    
                    // Update joined rooms list and sync
                    getJoinedRoomsForUser(matrixClient, dispatch);
                    await getRoomInitialSync(roomId, matrixClient, dispatch);
                    
                    return true;
                }
            }
            
            return false;
        }

    } catch (error) {
        console.error("❌ Unexpected error in verifyAndJoinStaffUser:", error);
        console.error("❌ Error details:", {
            message: error.message,
            stack: error.stack,
            name: error.name,
            httpStatus: error.httpStatus,
            errcode: error.errcode
        });
        
        return false;
    } finally {
        console.log("🔍 === verifyAndJoinStaffUser END ===");
    }
}

const inviteUsersToRoom = async (roomId, users, matrixClient, dispatch) => {
    console.log("🔍 === inviteUsersToRoom START ===");
    console.log("🔍 roomId:", roomId);
    console.log("🔍 users:", users);
    console.log("🔍 matrixClient:", matrixClient ? "exists" : "null");
    
    const results = {
        success: true,
        invitedCount: 0,
        errors: []
    };

    if (!matrixClient) {
        console.error("❌ Matrix client not available");
        results.success = false;
        results.errors.push("Matrix client not available");
        return results;
    }

    if (!roomId) {
        console.error("❌ Room ID not provided");
        results.success = false;
        results.errors.push("Room ID not provided");
        return results;
    }

    if (!users || users.length === 0) {
        console.error("❌ No users to invite");
        results.success = false;
        results.errors.push("No users to invite");
        return results;
    }

    try {
        console.log(`Inviting ${users.length} users to room ${roomId}`);
        
        // First, get current room members to avoid duplicate invitations
        let currentRoomMembers = {};
        try {
            console.log("Getting current room members before inviting...");
            const roomMembersResponse = await matrixClient.getJoinedRoomMembers(roomId);
            console.log("Room members response:", roomMembersResponse);
            currentRoomMembers = roomMembersResponse.joined || {};
            console.log("Current room members:", currentRoomMembers);
        } catch (error) {
            console.log("Could not get current room members, proceeding with invitations:", error.message);
        }
        
        for (const user of users) {
            try {
                if (!user.synapse_user_id) {
                    console.error(`User ${user._id} missing synapse_user_id`);
                    results.errors.push(`${user.firstname || user.username} missing chat credentials`);
                    continue;
                }

                // Check if user is already in the room (object format)
                const isAlreadyInRoom = currentRoomMembers.hasOwnProperty(user.synapse_user_id);
                if (isAlreadyInRoom) {
                    console.log(`User ${user.synapse_user_id} (${user.firstname} ${user.lastname}) is already in the room`);
                    results.invitedCount++;
                    continue;
                }

                console.log(`Inviting user ${user.synapse_user_id} (${user.firstname} ${user.lastname})`);
                
                // Only attempt to invite if not already in room
                const inviteResponse = await matrixClient.invite(roomId, user.synapse_user_id);
                console.log(`Invite response for ${user.synapse_user_id}:`, inviteResponse);
                
                if (inviteResponse && inviteResponse.room_id) {
                    console.log(`Successfully invited ${user.synapse_user_id}`);
                    results.invitedCount++;
                } else {
                    console.error(`Failed to invite ${user.synapse_user_id} - invalid response`);
                    results.errors.push(`Failed to invite ${user.firstname || user.username}`);
                }
                
            } catch (userError) {
                console.error(`Error inviting user ${user._id}:`, userError);
                
                // Check if user is already in room (from error message)
                if (userError.errcode === 'M_FORBIDDEN' && 
                    userError.message && 
                    userError.message.includes('already in the room')) {
                    console.log(`User ${user.synapse_user_id} is already in the room (from error)`);
                    results.invitedCount++;
                } else {
                    results.errors.push(`Failed to invite ${user.firstname || user.username}: ${userError.message}`);
                }
            }
        }

        // Determine overall success
        results.success = results.invitedCount > 0 && results.errors.length === 0;
        
        console.log(`Invitation results: ${results.invitedCount} successful, ${results.errors.length} errors`);
        
        if (results.invitedCount > 0) {
            // Update room members list after successful invitations
            console.log("Updating room members after invitations...");
            try {
                const updatedRoomMembersResponse = await matrixClient.getJoinedRoomMembers(roomId);
                console.log("Updated room members:", updatedRoomMembersResponse.joined);
            } catch (error) {
                console.log("Could not fetch updated room members:", error.message);
            }
        }
        
    } catch (error) {
        console.error("Unexpected error in inviteUsersToRoom:", error);
        results.success = false;
        results.errors.push(`Unexpected error: ${error.message}`);
    } finally {
        console.log("🔍 === inviteUsersToRoom END ===");
    }

    return results;
}

export {
    getMatrixClient,
    getMatrixServer,
    matrixInitialSync,
    getRoomInitialSync,
    getJoinedRoomsForUser,
    getRoomNotificationCounts,
    getRoomUnreadMsgCount,
    getTotalUnreadMsgCountForAppointment,
    updateRoomNotificationCount,
    markRead,
    joinUserRoom,
    verifyAndJoinStaffUser,
    inviteUsersToRoom,
    getUserGroups
}